import { getLogger } from "@hopin-team/provider-logging";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    SENTRY_RELEASE_VERSION,
    SENTRY_DSN,
    SENTRY_ENV,
    CONSUMER_ID,
  },
} = getConfig();

export const logger = getLogger({
  sentryDsn: SENTRY_DSN,
  sentryEnv: SENTRY_ENV,
  sentryRelease: SENTRY_RELEASE_VERSION,
  consumerId: CONSUMER_ID,
  customOptions: {
    ignoreErrors: [
      // These errors have consistently come from gtag over the past few months – they're benign so
      // should be safe to ignore.
      "TypeError: Illegal invocation",
      // https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value/14062/14
      "Non-Error promise rejection captured",
    ],
    normalizeDepth: 5,
  },
});

// use this logger object as a wrapper of logger imported from @hopin-team/fe-library
const loggerWithCustomTags = {
  info: logger.info,
  debug: logger.debug,
  warn: logger.warn,
  error: (error, secondaryTag) => {
    const customException = {
      error,
      customTags: {
        responsible_team: "page-builder",
        ...secondaryTag,
      },
    };
    logger.captureException(customException);
  },
};
export default loggerWithCustomTags;
